import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ChiSonoPage from "@/pages/ChiSonoPage";
import ServiziPage from "@/pages/ServiziPage";
import PrenotaPage from "@/pages/PrenotaPage";
import FAQPage from "@/pages/FAQPage";
import ContattiPage from "@/pages/ContattiPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import Admin from "@/pages/Admin";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-sono" element={<ChiSonoPage />} />
            <Route path="/servizi" element={<ServiziPage />} />
            <Route path="/prenota" element={<PrenotaPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contatti" element={<ContattiPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </div>
    </HelmetProvider>
  );
}

export default App;
